// extracted by mini-css-extract-plugin
export default {"form":"login-form_form__sPQJb","title":"login-form_title__PJTrk","description":"login-form_description__sV5Jv","forgot":"login-form_forgot__7I+bl"};